import React, { useEffect, useState } from "react";
import { getProtected } from "../../network/ApiService";
import { baseURL } from "../../network/baseUrl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


const BookValueHistory = (props) => {
  const { t } = props ; 
  const { id='', viewOnly = false  } = props;
  const [bookHistory, setBookHistory] = useState([]);
  const navigate = useNavigate();

  // 🔄 **Updated formatDate function**
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    // Use toLocaleDateString for the desired format: "10 Oct 2025"
    return date.toLocaleDateString("en-US", {
      day: "2-digit",   // e.g., '10'
      month: "short", // e.g., 'Oct'
      year: "numeric",  // e.g., '2025'
    });
  };

  const getBookHistory = async () => {
    if(id) 
    {
      try {
        const url = `${baseURL}/assets/${id}/book-value-history/`;
        if (!url) {
          throw new Error("API endpoint not defined");
        }
        const response = await getProtected(url);
        console.log("response = ", response);
        if (Array.isArray(response) && response?.length > 0) {
          console.log("setting book history = ", response);
          setBookHistory(response);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          toast.error(t("dashboardToasters.sessionExpiration"));
          navigate("/login");
          return;
        }
        toast.error(t("dashboardToasters.genricError"));
      }
    }
  };

  useEffect(() => {
    getBookHistory();
  }, []);

  return (
    <>
      <div className="p-6  bg-gray-50 max-h-400px ">
        <h4 className="text-md font-medium text-gray-700 mb-4">
         {t("bookValueModal.bookValueHistory")}
        </h4>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 ">
          <div className="flex items-center justify-between mb-3">
            <p className="text-sm text-gray-600">
            {t("bookValueModal.bookValueDesc")}
            </p>
          </div>

          <div className="overflow-x-auto ">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("bookValueModal.month")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("bookValueModal.bookValue")}
                  </th>
                 {!viewOnly  &&  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("bookValueModal.change")}
                  </th>}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 ">
                {bookHistory &&
                  bookHistory?.length > 0 &&
                  bookHistory.map((history, index) => {
                    return (
                      <tr key = {index} className="hover:bg-gray-50">
                        <td className="px-3 py-2 text-sm text-gray-900">
                          {formatDate(history?.date_recorded)} {/* **Format applied here** */}
                        </td>
                        <td className="px-3 py-2 text-sm text-gray-900">
                          €{history?.book_value}
                        </td>
                      { !viewOnly &&  <td className="px-3 py-2 text-sm text-red-600">
                          €
                          {(index + 1 < bookHistory?.length || 0) &&
                            history?.book_value -
                              bookHistory[index + 1]?.book_value}
                        </td>}
                      </tr>
                    );
                  })}
              
              </tbody>
            </table>
          </div>

          <div className="mt-3 text-xs text-gray-500">
          {t("bookValueModal.bookValueFooter")}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookValueHistory;